'use strict';

import axios from 'axios';
import { listenDOMEvent } from '@jspartials/dom-api-utils';
import { body } from '@jspartials/general-utils';
import { createElement, appendElementContent } from '@jspartials/dom-api-utils';
import { addToCartItem } from '@jspartials/cart-utils';
import {
  setHtmlScrollable,
  setHtmlUnscrollable
} from '@jspartials/general-utils';
import { classes, addClassToElement } from '@jspartials/class-list-utils';

const selectors = {
  cart: {
    addons: '.js-cart__recommendations-addons',
    tile: '.js-product-tile',
    tileLink: '.js-product-tile__link'
  },
  modal: {
    id: '#cartAddonsModal',
    wrapper: '.js-wrapper-modal-cart-addons',
    close: '.js-modal-close',
    button: '.js-button-add-to-cart',
    content: '.js-modal__content'
  }
};

const element = {
  cart: {
    addons: null
  },
  modal: {
    id: null,
    wrapper: null,
    close: null,
    button: null,
    content: null
  }
};

/**
 * Initializes the elements
 * @returns {void}
 */
const initElements = () => {
  element.modal.id = document.querySelector(selectors.modal.id) || null;
  element.modal.close = document.querySelector(selectors.modal.close) || null;
};

function closeModal() {
  setHtmlScrollable();
  if (element.modal.id) {
    element.modal.id.parentNode.remove();
  }
}

function openAddonModal(pidAddon) {
  setHtmlUnscrollable();
  if (element.modal.id) {
    element.modal.id.dataset.pid = pidAddon;
    addClassToElement(element.modal.id, classes.is.visible);
  }
}

const initEvents = () => {
  listenAddToCartButton();
  listenDOMEvent(window, 'click', function (event) {
    const modal = document.querySelector(selectors.modal.id);
    if (modal && !event.target.closest(selectors.modal.content)) {
      closeModal();
    }
  });
  if (element.modal.close) {
    element.modal.close.addEventListener('click', function (e) {
      closeModal();
    });
  }
};

const listenAddToCartButton = () => {
  const cartAddonsRecommenderAddToCartButton =
    element.modal.id.querySelector(selectors.modal.button) || null;

  if (cartAddonsRecommenderAddToCartButton) {
    listenDOMEvent(cartAddonsRecommenderAddToCartButton, 'click', () => {
      const productId = cartAddonsRecommenderAddToCartButton.dataset.pid || '';

      addToCartItem(productId, 1, 'cartRecommenderAddons', []);
      closeModal();
    });
  }
};

const getCartAddonsRecommender = () => {
  const url = globalVariables.endpoint.cartModalRecommenderAddons;

  const cartAddonsRecommender =
    document.querySelector(selectors.cart.addons) || null;

  if (cartAddonsRecommender) {
    const cartAddonsRecommenderTileLink =
      cartAddonsRecommender.querySelectorAll(selectors.cart.tileLink) || [];

    if (cartAddonsRecommenderTileLink) {
      cartAddonsRecommenderTileLink.forEach((tile) => {
        tile.removeAttribute('href');
        const pidAddon = tile.closest(selectors.cart.tile).dataset.pid;
        tile.addEventListener('click', (event) => {
          const formData = new FormData();
          formData.append('productId', pidAddon);
          axios
            .post(url, formData, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            })
            .then((response) => {
              const htmlModalCartRecommenderAddons = response.data.htmlText;
              const modalCartRecommenderAddons = createElement({
                tag: 'div',
                content: htmlModalCartRecommenderAddons
              });

              appendElementContent(body, modalCartRecommenderAddons);

              initElements();
              initEvents();
              openAddonModal(pidAddon);
            })
            .catch((error) => {
              console.error(error);
            });
        });
      });
    }
  }
};

export { getCartAddonsRecommender };
